import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["background", "children", "borderRadius", "padding", "variant"];
import { LayoutBoxBreezeBorder } from '../Layout/LayoutBoxBreezeBorder';
import { useTheme } from '../useTheme';
import { jsx as _jsx } from "react/jsx-runtime";
export const TileBreeze = _ref => {
  let {
      background = 'background-color-light',
      children,
      borderRadius: borderRadiusProvided,
      padding = 'space-md',
      variant
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isTrellisLight
  } = useTheme();
  const borderRadiusTheme = isTrellisLight ? 'border-radius-lg' : 'border-radius';
  const borderRadius = borderRadiusProvided || borderRadiusTheme;
  return /*#__PURE__*/_jsx(LayoutBoxBreezeBorder, Object.assign({}, rest, {
    background: background,
    borderRadius: borderRadius,
    padding: padding,
    variant: variant,
    children: children
  }));
};